<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import { store } from '../../state/store'
import Header from '@components/header.vue'

export default {
  page: {
    title: 'Site Details',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Header },
  data() {
    return {
      state: store.state,
      site: store.state.site,
    }
  },
}
</script>

<template>
  <Layout>
    <Header />
    <div :class="$style.site_details_parent_container">
      <div :class="$style.site_details_container">
        <div :class="$style.header_container">
          <h1 :class="$style.header">Site Details</h1>
          <h5 :class="$style.sub_header">Site Number: {{ site.siteNumber }}</h5>
        </div>
        <ul>
          <li>
            <label>Customer Name: </label><span> {{ site.siteName }} </span>
          </li>
          <li>
            <label>Address: </label
            ><a
              id="link-site-address"
              target="_blank"
              :href="site.googleMapsLink"
            >
              {{ site.siteAddress1 }} {{ site.siteAddress2 }},
              {{ site.cityName }}, {{ site.stateAbbr }} {{ site.zipCode }}</a
            >
          </li>
          <li>
            <label>Country: </label><span> {{ site.countryName }} </span>
          </li>
          <li>
            <label>Phone: </label
            ><a
              v-if="site.phone"
              id="link-site-phone"
              :href="'tel:' + site.phone"
            >
              {{ site.phone }}
            </a>
            <span v-else> No phone number to display.</span>
          </li>
          <li v-if="site.siteTypeId">
            <label>Site Type: </label><span> {{ site.siteTypeId }} </span>
          </li>
        </ul>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.site_details_container {
  max-width: $size-parent-container-width-max;
  padding: 1em;
  margin: auto;
}

.site_details_parent_container {
  position: relative;
  top: $height-status-bar;
  max-width: $size-parent-container-width-max;
  margin: auto;
  text-align: center;
}

.header_container {
  margin: 3em;
}

.header {
  margin-bottom: 0;
  color: $color-text-primary;
  text-align: center;
}

.sub_header {
  color: $color-text;
  text-align: center;
}

a {
  color: $color-text-primary;
}

a:visited {
  color: $color-text;
}

li {
  margin: 1em;
}
</style>
